import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carBlackWhiteList/task/page',
    method: 'post',
    data,
  })
}
export async function approval(data) {
  return request({
    url: '/carBlackWhiteList/task/check',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/carBlackWhiteList/revoke',
    method: 'post',
    data,
  })
}
